import Repository from './Repository';

const resource = "/assigned";
export default {
    page(page=1, limit=10, search='') {
        var offset = (page - 1) * limit
        if(search) { search = `&search=${search}` }
        return Repository.get(`${resource}/?limit=${limit}&offset=${offset}${search}`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}/`, data);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}/`)
    }
}